var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { colorTheme, textTheme } from "../themes";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: ", ";\n  width: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  box-sizing: border-box;\n  padding: 31px 0px;\n\n  &:hover {\n    cursor: pointer;\n    border: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: ", ";\n  width: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  box-sizing: border-box;\n  padding: 31px 0px;\n\n  &:hover {\n    cursor: pointer;\n    border: ",
    ";\n  }\n"])), function (props) { return props.height; }, function (props) { return props.width; }, colorTheme.divider, function (props) {
    return props.hoverOutline
        ? "1px solid " + colorTheme.newBlue + ";"
        : "1px solid " + colorTheme.divider + ";";
});
export var Title = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), textTheme.subtitle2, colorTheme.grayDark);
export var Value = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin: 5px 0px;\n"], ["\n  ", ";\n  color: ", ";\n  margin: 5px 0px;\n"])), textTheme.price, colorTheme.black);
var templateObject_1, templateObject_2, templateObject_3;
// export const Trend = styled.span<InformationTileProps>`
//   display: flex;
//   align-items: center;
//   ${textTheme["Tile-Trend"]}
//   color: ${props => (
//     props.trend && props.trend > 0
//     ? colorTheme.green
//     : colorTheme.red
//   )}
// `;
// export const Icon = styled.img`
//   margin-right: 4px;
// `;
//# sourceMappingURL=InformationTile.styles.js.map